export default __webpack_public_path__ + "static/media/dot-2.4f8b1996.jpg";